module.exports = __webpack_public_path__ + "static/media/icon-email.59ed2e77.svg";